export const smartChoiceFlex = (
  isMobileScreen,
  isMemberSelectedHeader,
  isMixedResultsPage,
  memberChangeHeader,
  showChoosePCPHeader
) => ({
  right: isMobileScreen
    ? isMemberSelectedHeader && isMixedResultsPage
      ? '0px'
      : isMemberSelectedHeader || showChoosePCPHeader
      ? '50px'
      : '30px'
    : memberChangeHeader
    ? '50px'
    : '60px',
  bottom: isMobileScreen
    ? isMemberSelectedHeader
      ? '30px'
      : '0px'
    : memberChangeHeader
    ? isMemberSelectedHeader
      ? '4px'
      : '16px'
    : '18px',
  top: isMobileScreen ? (isMemberSelectedHeader ? 'auto' : '18px') : 'auto',
});

export const smartChoiceLinkStyle = (isMobileScreen, paddingBottom) => ({
  fontWeight: '600',
  marginTop: '-6px',
  '& .abyss-insert-element-after': {
    alignItems: 'flex-end',
    '& svg': { fill: '$error1' },
    marginLeft: isMobileScreen ? '-20px' : '-8px',
  },
  '&:hover::before': { display: 'none' },
  paddingBottom: paddingBottom ? '8px' : '0px',
});

export const coachmarkStyle = (checkMobileScreen) => ({
  '& button span': { color: '$gray7 !important' },
  '&.abyss-popover-trigger': {
    marginTop: '2px',
  },
  '& .abyss-popover-header h2': { fontSize: '16px' },
  '&.abyss-popover-content': {
    zIndex: '99999 !important',
    backgroundColor: '#4B4D4F',
    width: '400px',
    maxWidth: 'calc(100vw - 120px)',
    '@media (max-width: 600px)': {
      width: 'calc(100vw - 120px)',
      maxWidth: 'calc(100vw - 120px)',
    },
    '@media (max-width: 380px)': {
      width: 'calc(100vw - 160px)',
      maxWidth: 'calc(100vw - 160px)',
    },
    borderWidth: '0px',
    marginTop: checkMobileScreen('20px', '-6px'),
    marginLeft: '160px',
    marginRight: checkMobileScreen('10px', '25px'),
    borderRadius: '8px',
    '& svg': {
      fill: '#4B4D4F',
      height: '14px',
      width: '24px',
    },
    '.abyss-popover-close-button': {
      '& span': {
        backgroundColor: '#4B4D4F',
        color: '#FFFFFF !important',
        '&:hover, &focus': {
          backgroundColor: '#4B4D4F !important',
        },
      },
      '&:hover': {
        backgroundColor: 'transparent !important',
      },
    },
    '.abyss-psx-parcel-c-jbfunX': {
      width: '100%',
      maxWidth: '100%',
      paddingRight: '40px',
      boxSizing: 'border-box',
      '@media (max-width: 600px)': {
        paddingRight: '35px',
      },
      '@media (max-width: 380px)': {
        paddingRight: '30px',
      },
    },
    '.abyss-popover-content-container': {
      color: '#FFFFFF',
      fontSize: '14px',
      fontFamily: '$primary',
      fontWeight: '400px',
    },
    '.abyss-popover-title': {
      color: '#FFFFFF',
      fontSize: '18px',
      fontFamily: '$primary',
      fontWeight: '500px',
    },
  },
});
